module.exports = __webpack_public_path__ + "img/vegetable-zucchini-190x100.fbfe1893.jpg";